<template>
    <div class="select-wrap">
		<div class="back" @click="goBack">< 返回</div>
		<img v-if="!showEditUser" src="../assets/login/middle.png" @click="goHome('C')" class="middle"></img>
		<img v-if="!showEditUser" src="../assets/login/high.png" @click="goHome('G')" class="high"></img>
		<edit-user class="edit-user" :select="true" v-if="showEditUser" />
    </div>
</template>
<script>
import EditUser from "../components/EditUser.vue";
export default {
	name: 'index',
	components: {
		EditUser
	},
	data(){
		return {
			userName:"",
			showEditUser:false
		}
	},

	created(){
		this.userName = JSON.parse(localStorage.getItem('userInfo')).userName
	},
	mounted() {
	},

	computed: {

	},
	watch: {

	},
	methods: {
		goHome(schoolType){
			localStorage.setItem("schoolType",schoolType)
			localStorage.setItem('courseHot',true)
			localStorage.setItem('testHot',true)
			if(this.userName){
				this.$router.push({  //核心语句
				  path:'/home',   //跳转的路径
				  query:{}
				})
			}else{
				this.showEditUser = true
			}
		},
		goBack(){
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped>
.select-wrap{
	width: 100vw;
	height: 100vh;
	background-image: url(../assets/login/bg.png);
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	.back{
		position: absolute;
		z-index: 1;
		top: 1.5rem;
		left: 2rem;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		color: #FFFFFF;
		line-height: 1.88rem;
	}
	img{
		width: 27.05rem;
		height: 33.85rem;
		border-radius: 0rem 0rem 0rem 0rem;
		margin: 0 4.5rem;
	}
	.edit-user{
		width: 90%;
		height: 90%;
	}
}
</style>
